import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@/components/accordion';
import { Loader } from '@/components/shared/loader';
import { pluralize } from '@/utils/string';
import { SelectedItemsBody } from './selectedItemsBody';
import { SelectedItemsHeader } from './selectedItemsHeader';
export const SelectionPanel = t0 => {
  const $ = _c(15);
  const {
    isLoading,
    drawerProps,
    children
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const showDrawer = drawerProps.items.length > 0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Stack className="h-[220px]"><Loader /></Stack>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = showDrawer ? "60px" : 0;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      paddingBottom: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setExpanded(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = expanded ? "block" : "none";
  let t5;
  if ($[4] !== t4) {
    t5 = <Stack className="absolute top-0 left-0 w-full h-full" onClick={t3} sx={{
      background: "var(--mui-palette-primary-mainOpacity)",
      display: t4,
      zIndex: 1
    }} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== drawerProps || $[7] !== expanded || $[8] !== showDrawer) {
    t6 = showDrawer && <SelectedItemsDrawer {...drawerProps} expanded={expanded} setExpanded={setExpanded} />;
    $[6] = drawerProps;
    $[7] = expanded;
    $[8] = showDrawer;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== children || $[11] !== t2 || $[12] !== t5 || $[13] !== t6) {
    t7 = <Stack className="max-h-[480px] overflow-hidden" sx={t2}>{children}{t5}{t6}</Stack>;
    $[10] = children;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
interface SelectedItemsDrawerProps<T> {
  entityType: string;
  items: T[];
  onRemove: (item: T) => void;
  renderItem: (item: T) => React.ReactNode;
  itemKey: (item: T) => string;
  clearAll: () => void;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}
const SelectedItemsDrawer = t0 => {
  const $ = _c(29);
  const {
    entityType,
    items,
    renderItem,
    itemKey,
    onRemove,
    clearAll,
    expanded,
    setExpanded
  } = t0;
  let t1;
  if ($[0] !== expanded || $[1] !== items.length || $[2] !== setExpanded) {
    t1 = items.length ? () => setExpanded(!expanded) : undefined;
    $[0] = expanded;
    $[1] = items.length;
    $[2] = setExpanded;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      zIndex: 2,
      maxHeight: "calc(100% - 60px)",
      backgroundColor: "var(--mui-palette-background-paper)",
      "& .MuiCollapse-root": {
        backgroundColor: "var(--mui-palette-background-paper)",
        position: "relative",
        overflow: "auto"
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      boxShadow: "var(--mui-customShadows-panelUp)"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entityType || $[7] !== items.length) {
    t4 = items.length === 1 ? entityType : pluralize(entityType);
    $[6] = entityType;
    $[7] = items.length;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `${items.length} ${t4} selected`;
  let t6;
  if ($[9] !== clearAll || $[10] !== setExpanded) {
    t6 = () => {
      clearAll();
      setExpanded(false);
    };
    $[9] = clearAll;
    $[10] = setExpanded;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <AccordionSummary className="min-h-[64px] h-[64px] px-[24px]" sx={t3}><SelectedItemsHeader title={t5} clearAll={t6} /></AccordionSummary>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== items.length || $[16] !== onRemove || $[17] !== setExpanded) {
    t8 = item => {
      if (items.length === 1) {
        setExpanded(false);
      }
      onRemove(item);
    };
    $[15] = items.length;
    $[16] = onRemove;
    $[17] = setExpanded;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== itemKey || $[20] !== items || $[21] !== renderItem || $[22] !== t8) {
    t9 = <AccordionDetails className="p-0 overflow-auto"><SelectedItemsBody items={items} renderItem={renderItem} itemKey={itemKey} onRemove={t8} /></AccordionDetails>;
    $[19] = itemKey;
    $[20] = items;
    $[21] = renderItem;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== expanded || $[25] !== t1 || $[26] !== t7 || $[27] !== t9) {
    t10 = <Accordion expanded={expanded} onChange={t1} className="p-0 m-0 flex flex-col absolute bottom-0 left-0 right-0" sx={t2}>{t7}{t9}</Accordion>;
    $[24] = expanded;
    $[25] = t1;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};